var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgThinArrowRight = function SvgThinArrowRight(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 16,
    viewBox: "0 0 100 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.6123 8.99422C100.003 8.60369 100.003 7.97053 99.6123 7.58L93.2483 1.21604C92.8578 0.825517 92.2246 0.825517 91.8341 1.21604C91.4436 1.60657 91.4436 2.23973 91.8341 2.63026L97.4909 8.28711L91.8341 13.944C91.4436 14.3345 91.4436 14.9677 91.8341 15.3582C92.2246 15.7487 92.8578 15.7487 93.2483 15.3582L99.6123 8.99422ZM0.968384 9.28711H98.9052V7.28711H0.968384V9.28711Z",
    fill: "#2D0AEA"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgThinArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thin-arrow-right.4403bd802ce71b3decb9b2c099293b39.svg";